// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}

.btn::after {
  content: none !important;
  display: none !important;
}

.equipment-page {
  background: var(--background-gray, var(--light));
  box-sizing: border-box;
  flex: 1 1 auto;
  margin: 0 auto !important;
  max-width: 1920px !important;
  min-height: 0;
  overflow: auto;
  padding: 0.65rem clamp(0.65rem, 2vw, 1.4rem) 0.75rem;
  width: 96% !important;
}

.page-heading {
  background: #fff;
  border: 1px solid #dee2e6;
  border-left: 4px solid var(--primary);
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 1.2rem !important;
  max-width: none !important;
  min-height: 58px !important;
  padding: 0.9rem clamp(1rem, 3vw, 2rem);
  position: relative;
  text-align: center;
  width: auto !important;
}

.page-heading::before,
.page-heading::after {
  content: none !important;
  display: none !important;
}

.page-heading__title {
  flex: 1 1 auto;
}

.page-heading h1 {
  color: var(--dark);
  font-size: clamp(1.3rem, 2vw, 1.65rem);
  font-weight: 700;
  line-height: 1.15;
  margin: 0;
}

.page-heading p {
  margin: 0;
}

.eyebrow {
  color: var(--primary);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin-bottom: 0.15rem !important;
  text-transform: uppercase;
}

.page-introduction {
  color: var(--secondary);
  font-size: 0.82rem;
  margin-top: 0.25rem !important;
}

.page-actions {
  display: flex;
  gap: 0.6rem;
  position: absolute;
  right: clamp(1rem, 3vw, 2rem);
}

.page-actions .btn-outline-primary {
  background: #fff;
  border-color: var(--primary);
  color: var(--primary);
}

.page-actions .btn-outline-primary:hover, .page-actions .btn-outline-primary:focus-visible {
  background: var(--primary);
  color: #fff;
}

.nextpage-action {
  align-items: center;
  display: inline-flex;
  gap: 0.35rem;
  justify-content: center;
}

.nextpage-action mat-icon {
  font-size: 1.1rem;
  height: 1.1rem;
  line-height: 1.1rem;
  width: 1.1rem;
}

.list-toolbar {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  margin: -0.55rem 0 0.7rem;
}

.list-toolbar__label {
  color: var(--secondary);
  font-size: 0.78rem;
  font-weight: 700;
}

:host ::ng-deep .list-toolbar .mat-button-toggle-group,
:host ::ng-deep .list-toolbar .mat-button-toggle {
  height: 56px;
}

:host ::ng-deep .list-toolbar .mat-button-toggle-label-content {
  line-height: 54px;
  padding: 0 14px;
}

:host ::ng-deep .list-toolbar .mat-button-toggle-checked {
  background: var(--primary);
  color: #fff;
}

.table-shell {
  border: 1px solid #dee2e6;
  border-radius: 4px 4px 0 0;
  overflow: visible;
  position: relative;
}

.table-loading-bar {
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 5;
}

table {
  height: auto;
  margin: 0;
  table-layout: fixed;
  width: 100%;
  min-width: 1610px;
}

.mat-mdc-header-row {
  background: #fff;
  position: sticky;
}

.column-header-row {
  height: 56px;
  top: 0;
  z-index: 4 !important;
}

.filter-header-row {
  top: 56px;
  z-index: 3 !important;
}

.mat-column-equipmentNumber, .mat-column-equipmentNumberFilter {
  width: 135px;
}

.mat-column-name, .mat-column-nameFilter {
  width: 210px;
}

.mat-column-manufacturer, .mat-column-manufacturerFilter {
  width: 170px;
}

.mat-column-modelNumber, .mat-column-modelNumberFilter {
  width: 145px;
}

.mat-column-serialNumber, .mat-column-serialNumberFilter {
  width: 145px;
}

.mat-column-assetNumber, .mat-column-assetNumberFilter {
  width: 135px;
}

.mat-column-location, .mat-column-locationFilter {
  width: 180px;
}

.mat-column-vendorDueStatus, .mat-column-vendorDueStatusFilter,
.mat-column-labDueStatus, .mat-column-labDueStatusFilter {
  width: 165px;
}

.mat-column-actions, .mat-column-actionsFilter {
  width: 185px;
}

.filter-header-row {
  background: #f8f9fa;
  height: 56px;
}

.filter-header-cell {
  border-bottom-color: #ced4da;
  padding: 8px 10px;
}

.column-filter-input,
.column-filter-select {
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-sizing: border-box;
  color: var(--dark);
  font-size: 0.82rem;
  height: 38px;
  padding: 0.45rem 0.6rem;
  width: 100%;
}

.column-filter-input:focus,
.column-filter-select:focus {
  border-color: var(--primary);
  outline: 2px solid color-mix(in srgb, var(--primary) 24%, transparent);
  outline-offset: 1px;
}

.column-filter-input::placeholder {
  color: var(--secondary);
  font-style: italic;
}

.filter-actions-cell {
  text-align: right;
}

.clear-filters {
  align-items: center;
  background: #fff;
  border: 1px solid var(--primary);
  border-radius: 0.25rem;
  color: var(--primary);
  cursor: pointer;
  display: inline-flex;
  height: 38px;
  justify-content: center;
  padding: 0;
  width: 38px;
}

.clear-filters:hover:not(:disabled), .clear-filters:focus-visible:not(:disabled) {
  background: var(--primary);
  color: #fff;
}

.clear-filters:disabled {
  border-color: var(--secondary);
  color: var(--secondary);
  cursor: default;
  opacity: 0.35;
}

.clear-filters mat-icon {
  font-size: 1.2rem;
  height: 1.2rem;
  line-height: 1.2rem;
  width: 1.2rem;
}

.no-data-row td {
  color: var(--secondary);
  padding: 2rem;
  text-align: center;
}

.instrument-row {
  cursor: pointer;
  height: 40px;
}

.instrument-row:hover {
  background: var(--light);
}

.instrument-row:focus-visible {
  outline: 3px solid var(--primary);
  outline-offset: -3px;
}

.actions-cell {
  white-space: nowrap;
  text-align: right;
}

.actions-cell .icon-action + .icon-action {
  margin-left: 0.4rem;
}

.removed-row {
  background: var(--light);
  color: var(--secondary);
}

.removed-label {
  display: inline-block;
  margin-right: 0.35rem;
  padding: 3px 9px;
  border-radius: 12px;
  background: var(--secondary);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
}

.due-status {
  color: var(--secondary);
  font-size: 0.74rem;
  font-weight: 700;
}

.due-status[data-status=Overdue] {
  color: var(--danger);
}

.due-status[data-status=Due] {
  color: #b54708;
}

.due-status[data-status=DueSoon] {
  color: #8a6100;
}

.due-status[data-status=Current] {
  color: #18794e;
}

.icon-action {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  min-height: 34px;
  min-width: 34px;
  padding: 0.25rem;
}

.icon-action mat-icon {
  font-size: 1.25rem;
  height: 1.25rem;
  line-height: 1.25rem;
  width: 1.25rem;
}

.icon-action--primary {
  background: #fff !important;
  border: 1px solid var(--primary) !important;
  color: var(--primary) !important;
}

.icon-action--primary:hover,
.icon-action--primary:focus-visible {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
  color: #fff !important;
}

.icon-action--danger {
  background: #fff !important;
  border: 1px solid var(--danger) !important;
  color: var(--danger) !important;
}

.icon-action--danger:hover,
.icon-action--danger:focus-visible {
  background: var(--danger) !important;
  border-color: var(--danger) !important;
  color: #fff !important;
}

:host ::ng-deep .mat-mdc-checkbox {
  --mdc-checkbox-selected-checkmark-color: #fff;
  --mdc-checkbox-selected-focus-icon-color: var(--primary);
  --mdc-checkbox-selected-hover-icon-color: var(--primary);
  --mdc-checkbox-selected-icon-color: var(--primary);
  --mdc-checkbox-selected-pressed-icon-color: var(--primary);
}

:host ::ng-deep .mat-mdc-form-field {
  --mdc-outlined-text-field-focus-label-text-color: var(--primary);
  --mdc-outlined-text-field-focus-outline-color: var(--primary);
  --mat-select-focused-arrow-color: var(--primary);
}

:host ::ng-deep .column-filter-select .mat-mdc-select-trigger {
  height: 100%;
}

:host ::ng-deep .column-filter-select .mat-mdc-select-value {
  align-items: center;
  display: flex;
}

.state {
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--secondary);
  text-align: center;
}

.state h2, .state p {
  margin: 0;
}

.state--error {
  color: var(--danger);
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 950px) {
  .page-heading {
    align-items: stretch;
    flex-direction: column;
    gap: 0.75rem;
  }
  .page-actions {
    justify-content: center;
    position: static;
  }
}
@media (max-width: 700px) {
  .equipment-page {
    padding: 0.65rem;
    width: 100% !important;
  }
  .page-heading {
    align-items: stretch;
    flex-direction: column;
    gap: 0.75rem;
    padding: 0.9rem 1rem;
  }
  .page-actions {
    flex-direction: column;
    position: static;
  }
  .page-actions button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/lab-equipment/lab-equipment.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,cAAA;EACA,aAAA;AACF;;AAEA;EACE,wBAAA;EACA,wBAAA;AACF;;AAEA;EACE,gDAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,aAAA;EACA,cAAA;EACA,oDAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AACF;;AAEA;;EAEE,wBAAA;EACA,wBAAA;AACF;;AAEA;EAAuB,cAAA;AAEvB;;AAAA;EACE,kBAAA;EACA,sCAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AAGF;;AAAA;EAAkB,SAAA;AAIlB;;AAHA;EAAW,qBAAA;EAAuB,iBAAA;EAAkB,gBAAA;EAAkB,sBAAA;EAAuB,iCAAA;EAAkC,yBAAA;AAY/H;;AAXA;EAAqB,uBAAA;EAAyB,kBAAA;EAAmB,8BAAA;AAiBjE;;AAhBA;EAAgB,aAAA;EAAe,WAAA;EAAY,kBAAA;EAAoB,6BAAA;AAuB/D;;AAtBA;EAAqC,gBAAA;EAAkB,4BAAA;EAA8B,qBAAA;AA4BrF;;AA3BA;EAA6F,0BAAA;EAA4B,WAAA;AAgCzH;;AA/BA;EAAmB,mBAAA;EAAqB,oBAAA;EAAsB,YAAA;EAAa,uBAAA;AAsC3E;;AArCA;EAA4B,iBAAA;EAAmB,cAAA;EAAgB,mBAAA;EAAqB,aAAA;AA4CpF;;AA3CA;EAAgB,mBAAA;EAAqB,aAAA;EAAe,YAAA;EAAa,yBAAA;EAA2B,yBAAA;AAmD5F;;AAlDA;EAAuB,uBAAA;EAAyB,kBAAA;EAAmB,gBAAA;AAwDnE;;AAvDA;;EACmD,YAAA;AA2DnD;;AA1DA;EAAiE,iBAAA;EAAmB,eAAA;AA+DpF;;AA9DA;EAA2D,0BAAA;EAA4B,WAAA;AAmEvF;;AAjEA;EAAe,yBAAA;EAA2B,0BAAA;EAA4B,iBAAA;EAAmB,kBAAA;AAwEzF;;AAvEA;EAAqB,OAAA;EAAS,kBAAA;EAAoB,QAAA;EAAU,MAAA;EAAQ,UAAA;AA+EpE;;AA9EA;EAAQ,YAAA;EAAc,SAAA;EAAW,mBAAA;EAAqB,WAAA;EAAa,iBAAA;AAsFnE;;AArFA;EAAsB,gBAAA;EAAkB,gBAAA;AA0FxC;;AAzFA;EAAqB,YAAA;EAAc,MAAA;EAAQ,qBAAA;AA+F3C;;AA9FA;EAAqB,SAAA;EAAW,qBAAA;AAmGhC;;AAlGA;EAAiE,YAAA;AAsGjE;;AArGA;EAA2C,YAAA;AAyG3C;;AAxGA;EAA2D,YAAA;AA4G3D;;AA3GA;EAAyD,YAAA;AA+GzD;;AA9GA;EAA2D,YAAA;AAkH3D;;AAjHA;EAAyD,YAAA;AAqHzD;;AApHA;EAAmD,YAAA;AAwHnD;;AAvHA;;EAC2D,YAAA;AA2H3D;;AA1HA;EAAiD,YAAA;AA8HjD;;AA7HA;EAAqB,mBAAA;EAAqB,YAAA;AAkI1C;;AAjIA;EAAsB,4BAAA;EAA8B,iBAAA;AAsIpD;;AArIA;;EAEE,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;AAwIF;;AAtIA;;EAC8B,4BAAA;EAA8B,sEAAA;EAAwE,mBAAA;AA4IpI;;AA3IA;EAAoC,uBAAA;EAAyB,kBAAA;AAgJ7D;;AA/IA;EAAuB,iBAAA;AAmJvB;;AAlJA;EAAiB,mBAAA;EAAqB,gBAAA;EAAkB,gCAAA;EAAkC,sBAAA;EAAuB,qBAAA;EAAuB,eAAA;EAAiB,oBAAA;EAAsB,YAAA;EAAc,uBAAA;EAAyB,UAAA;EAAY,WAAA;AAgKlO;;AA/JA;EAAmF,0BAAA;EAA4B,WAAA;AAoK/G;;AAnKA;EAA0B,8BAAA;EAAgC,uBAAA;EAAyB,eAAA;EAAiB,aAAA;AA0KpG;;AAzKA;EAA0B,iBAAA;EAAmB,cAAA;EAAgB,mBAAA;EAAqB,aAAA;AAgLlF;;AA/KA;EAAkB,uBAAA;EAAyB,aAAA;EAAe,kBAAA;AAqL1D;;AApLA;EAAkB,eAAA;EAAiB,YAAA;AAyLnC;;AAxLA;EAAwB,wBAAA;AA4LxB;;AA3LA;EAAgC,iCAAA;EAAmC,oBAAA;AAgMnE;;AA/LA;EAAgB,mBAAA;EAAqB,iBAAA;AAoMrC;;AAnMA;EAA4C,mBAAA;AAuM5C;;AAtMA;EAAe,wBAAA;EAA0B,uBAAA;AA2MzC;;AA1MA;EAAiB,qBAAA;EAAuB,qBAAA;EAAsB,gBAAA;EAAkB,mBAAA;EAAqB,4BAAA;EAA8B,WAAA;EAAa,kBAAA;EAAmB,gBAAA;AAqNnK;;AApNA;EAAc,uBAAA;EAAyB,kBAAA;EAAmB,gBAAA;AA0N1D;;AAzNA;EAAqC,oBAAA;AA6NrC;;AA5NA;EAAiC,cAAA;AAgOjC;;AA/NA;EAAqC,cAAA;AAmOrC;;AAlOA;EAAqC,cAAA;AAsOrC;;AArOA;EAAe,mBAAA;EAAqB,oBAAA;EAAsB,uBAAA;EAAyB,gBAAA;EAAkB,eAAA;EAAiB,gBAAA;AA8OtH;;AA7OA;EAAwB,kBAAA;EAAoB,eAAA;EAAiB,oBAAA;EAAsB,cAAA;AAoPnF;;AAnPA;EACE,2BAAA;EACA,2CAAA;EACA,gCAAA;AAsPF;;AApPA;;EAEE,qCAAA;EACA,uCAAA;EACA,sBAAA;AAuPF;;AArPA;EACE,2BAAA;EACA,0CAAA;EACA,+BAAA;AAwPF;;AAtPA;;EAEE,oCAAA;EACA,sCAAA;EACA,sBAAA;AAyPF;;AAtPA;EACE,6CAAA;EACA,wDAAA;EACA,wDAAA;EACA,kDAAA;EACA,0DAAA;AAyPF;;AAtPA;EACE,gEAAA;EACA,6DAAA;EACA,gDAAA;AAyPF;;AAvPA;EAAgE,YAAA;AA2PhE;;AA1PA;EAA8D,mBAAA;EAAqB,aAAA;AA+PnF;;AA7PA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;AAgQF;;AA9PA;EAAsB,SAAA;AAkQtB;;AAjQA;EAAgB,oBAAA;AAqQhB;;AApQA;EAAmB,kBAAA;EAAoB,UAAA;EAAY,WAAA;EAAa,UAAA;EAAY,YAAA;EAAc,gBAAA;EAAkB,sBAAA;EAAwB,mBAAA;EAAqB,SAAA;AAgRzJ;;AA9QA;EACE;IAAgB,oBAAA;IAAsB,sBAAA;IAAwB,YAAA;EAoR9D;EAnRA;IAAgB,uBAAA;IAAyB,gBAAA;EAuRzC;AACF;AArRA;EACE;IAAkB,gBAAA;IAAiB,sBAAA;EAyRnC;EAxRA;IAAgB,oBAAA;IAAsB,sBAAA;IAAwB,YAAA;IAAa,oBAAA;EA8R3E;EA7RA;IAAgB,sBAAA;IAAwB,gBAAA;EAiSxC;EAhSA;IAAuB,WAAA;EAmSvB;AACF","sourcesContent":[":host {\n  display: flex;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.btn::after {\n  content: none !important;\n  display: none !important;\n}\n\n.equipment-page {\n  background: var(--background-gray, var(--light));\n  box-sizing: border-box;\n  flex: 1 1 auto;\n  margin: 0 auto !important;\n  max-width: 1920px !important;\n  min-height: 0;\n  overflow: auto;\n  padding: 0.65rem clamp(0.65rem, 2vw, 1.4rem) 0.75rem;\n  width: 96% !important;\n}\n\n.page-heading {\n  background: #fff;\n  border: 1px solid #dee2e6;\n  border-left: 4px solid var(--primary);\n  border-radius: 7px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 0 1.2rem !important;\n  max-width: none !important;\n  min-height: 58px !important;\n  padding: 0.9rem clamp(1rem, 3vw, 2rem);\n  position: relative;\n  text-align: center;\n  width: auto !important;\n}\n\n.page-heading::before,\n.page-heading::after {\n  content: none !important;\n  display: none !important;\n}\n\n.page-heading__title { flex: 1 1 auto; }\n\n.page-heading h1 {\n  color: var(--dark);\n  font-size: clamp(1.3rem, 2vw, 1.65rem);\n  font-weight: 700;\n  line-height: 1.15;\n  margin: 0;\n}\n\n.page-heading p { margin: 0; }\n.eyebrow { color: var(--primary); font-size: .7rem; font-weight: 700; letter-spacing: .08em; margin-bottom: .15rem !important; text-transform: uppercase; }\n.page-introduction { color: var(--secondary); font-size: .82rem; margin-top: .25rem !important; }\n.page-actions { display: flex; gap: .6rem; position: absolute; right: clamp(1rem, 3vw, 2rem); }\n.page-actions .btn-outline-primary { background: #fff; border-color: var(--primary); color: var(--primary); }\n.page-actions .btn-outline-primary:hover, .page-actions .btn-outline-primary:focus-visible { background: var(--primary); color: #fff; }\n.nextpage-action { align-items: center; display: inline-flex; gap: .35rem; justify-content: center; }\n.nextpage-action mat-icon { font-size: 1.1rem; height: 1.1rem; line-height: 1.1rem; width: 1.1rem; }\n.list-toolbar { align-items: center; display: flex; gap: .75rem; justify-content: flex-end; margin: -.55rem 0 .7rem; }\n.list-toolbar__label { color: var(--secondary); font-size: .78rem; font-weight: 700; }\n:host ::ng-deep .list-toolbar .mat-button-toggle-group,\n:host ::ng-deep .list-toolbar .mat-button-toggle { height: 56px; }\n:host ::ng-deep .list-toolbar .mat-button-toggle-label-content { line-height: 54px; padding: 0 14px; }\n:host ::ng-deep .list-toolbar .mat-button-toggle-checked { background: var(--primary); color: #fff; }\n\n.table-shell { border: 1px solid #dee2e6; border-radius: 4px 4px 0 0; overflow: visible; position: relative; }\n.table-loading-bar { left: 0; position: absolute; right: 0; top: 0; z-index: 5; }\ntable { height: auto; margin: 0; table-layout: fixed; width: 100%; min-width: 1610px; }\n.mat-mdc-header-row { background: #fff; position: sticky; }\n.column-header-row { height: 56px; top: 0; z-index: 4 !important; }\n.filter-header-row { top: 56px; z-index: 3 !important; }\n.mat-column-equipmentNumber, .mat-column-equipmentNumberFilter { width: 135px; }\n.mat-column-name, .mat-column-nameFilter { width: 210px; }\n.mat-column-manufacturer, .mat-column-manufacturerFilter { width: 170px; }\n.mat-column-modelNumber, .mat-column-modelNumberFilter { width: 145px; }\n.mat-column-serialNumber, .mat-column-serialNumberFilter { width: 145px; }\n.mat-column-assetNumber, .mat-column-assetNumberFilter { width: 135px; }\n.mat-column-location, .mat-column-locationFilter { width: 180px; }\n.mat-column-vendorDueStatus, .mat-column-vendorDueStatusFilter,\n.mat-column-labDueStatus, .mat-column-labDueStatusFilter { width: 165px; }\n.mat-column-actions, .mat-column-actionsFilter { width: 185px; }\n.filter-header-row { background: #f8f9fa; height: 56px; }\n.filter-header-cell { border-bottom-color: #ced4da; padding: 8px 10px; }\n.column-filter-input,\n.column-filter-select {\n  background: #fff;\n  border: 1px solid #ced4da;\n  border-radius: .25rem;\n  box-sizing: border-box;\n  color: var(--dark);\n  font-size: .82rem;\n  height: 38px;\n  padding: .45rem .6rem;\n  width: 100%;\n}\n.column-filter-input:focus,\n.column-filter-select:focus { border-color: var(--primary); outline: 2px solid color-mix(in srgb, var(--primary) 24%, transparent); outline-offset: 1px; }\n.column-filter-input::placeholder { color: var(--secondary); font-style: italic; }\n.filter-actions-cell { text-align: right; }\n.clear-filters { align-items: center; background: #fff; border: 1px solid var(--primary); border-radius: .25rem; color: var(--primary); cursor: pointer; display: inline-flex; height: 38px; justify-content: center; padding: 0; width: 38px; }\n.clear-filters:hover:not(:disabled), .clear-filters:focus-visible:not(:disabled) { background: var(--primary); color: #fff; }\n.clear-filters:disabled { border-color: var(--secondary); color: var(--secondary); cursor: default; opacity: .35; }\n.clear-filters mat-icon { font-size: 1.2rem; height: 1.2rem; line-height: 1.2rem; width: 1.2rem; }\n.no-data-row td { color: var(--secondary); padding: 2rem; text-align: center; }\n.instrument-row { cursor: pointer; height: 40px; }\n.instrument-row:hover { background: var(--light); }\n.instrument-row:focus-visible { outline: 3px solid var(--primary); outline-offset: -3px; }\n.actions-cell { white-space: nowrap; text-align: right; }\n.actions-cell .icon-action + .icon-action { margin-left: .4rem; }\n.removed-row { background: var(--light); color: var(--secondary); }\n.removed-label { display: inline-block; margin-right: .35rem; padding: 3px 9px; border-radius: 12px; background: var(--secondary); color: #fff; font-size: .75rem; font-weight: 600; }\n.due-status { color: var(--secondary); font-size: .74rem; font-weight: 700; }\n.due-status[data-status=\"Overdue\"] { color: var(--danger); }\n.due-status[data-status=\"Due\"] { color: #b54708; }\n.due-status[data-status=\"DueSoon\"] { color: #8a6100; }\n.due-status[data-status=\"Current\"] { color: #18794e; }\n.icon-action { align-items: center; display: inline-flex; justify-content: center; min-height: 34px; min-width: 34px; padding: .25rem; }\n.icon-action mat-icon { font-size: 1.25rem; height: 1.25rem; line-height: 1.25rem; width: 1.25rem; }\n.icon-action--primary {\n  background: #fff !important;\n  border: 1px solid var(--primary) !important;\n  color: var(--primary) !important;\n}\n.icon-action--primary:hover,\n.icon-action--primary:focus-visible {\n  background: var(--primary) !important;\n  border-color: var(--primary) !important;\n  color: #fff !important;\n}\n.icon-action--danger {\n  background: #fff !important;\n  border: 1px solid var(--danger) !important;\n  color: var(--danger) !important;\n}\n.icon-action--danger:hover,\n.icon-action--danger:focus-visible {\n  background: var(--danger) !important;\n  border-color: var(--danger) !important;\n  color: #fff !important;\n}\n\n:host ::ng-deep .mat-mdc-checkbox {\n  --mdc-checkbox-selected-checkmark-color: #fff;\n  --mdc-checkbox-selected-focus-icon-color: var(--primary);\n  --mdc-checkbox-selected-hover-icon-color: var(--primary);\n  --mdc-checkbox-selected-icon-color: var(--primary);\n  --mdc-checkbox-selected-pressed-icon-color: var(--primary);\n}\n\n:host ::ng-deep .mat-mdc-form-field {\n  --mdc-outlined-text-field-focus-label-text-color: var(--primary);\n  --mdc-outlined-text-field-focus-outline-color: var(--primary);\n  --mat-select-focused-arrow-color: var(--primary);\n}\n:host ::ng-deep .column-filter-select .mat-mdc-select-trigger { height: 100%; }\n:host ::ng-deep .column-filter-select .mat-mdc-select-value { align-items: center; display: flex; }\n\n.state {\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: var(--secondary);\n  text-align: center;\n}\n.state h2, .state p { margin: 0; }\n.state--error { color: var(--danger); }\n.visually-hidden { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0; }\n\n@media (max-width: 950px) {\n  .page-heading { align-items: stretch; flex-direction: column; gap: .75rem; }\n  .page-actions { justify-content: center; position: static; }\n}\n\n@media (max-width: 700px) {\n  .equipment-page { padding: .65rem; width: 100% !important; }\n  .page-heading { align-items: stretch; flex-direction: column; gap: .75rem; padding: .9rem 1rem; }\n  .page-actions { flex-direction: column; position: static; }\n  .page-actions button { width: 100%; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
